
import { computed, defineComponent, onMounted, PropType, ref, watch } from 'vue';
import { Chart, SeriesDataItem } from '@/components';
import { EChartOption } from 'echarts';

type PieDataType = number[] | number[][] | EChartOption.SeriesPie.DataObject[];

const COLOR = '#666';

export default defineComponent({
  props: {
    data: {
      type: Array as PropType<SeriesDataItem[]>,
      default: () => [],
    },
    height: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: '',
    },
    options: {
      type: Object,
      default: () => {},
    },
    valueLabel: {
      type: String,
      default: () => undefined,
    },
  },
  setup(props: any) {
    const chartOption = {
      title: {
        text: props.title,
      },
      tooltip: {
        trigger: 'item',
      },
      color: ['#1790ff', '#12c2c2', '#2fc25b', '#f04864', '#8542e0', '#4C5058', '#8C8D8E'],
      legend: {
        // orient: 'vertical',
        // left: 'left',
        show: false,
        data: [] as string[],
      },
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)',
        },
      },
      series: [
        {
          name: props.title,
          center: ['50%', '50%'],
          radius: '55%',
          type: 'pie',
          itemStyle: {
            //图形样式
            normal: {
              borderColor: '#fff',
              borderWidth: 1,
            },
          },
          labelLine: {
            show: true,
            length: 1,
          },
          label: {
            formatter: '{b|{b}:\r}{d}%\n',
            borderWidth: 0,
            borderRadius: 4,
            overflow: 'breakAll',
            position: 'outer',
            alignTo: 'edge',
            bleedMargin: 5,
            margin: 2,
            rich: {
              a: {
                color: '#6E7079',
                lineHeight: 22,
                align: 'center',
              },
              b: {
                color: '#4C5058',
                fontSize: 14,
                fontWeight: 'bold',
                lineHeight: 33,
              },
            },
          },
          tooltip: {
            formatter: props.options?.tooltip_formatter,
          },
          data: [],
        },
      ] as EChartOption.SeriesPie[],
    };

    const refChartOption = ref(chartOption);

    const chartHeight = computed(() => `${props.height}px`);
    const setChartOption = (data: any[]) => {
      const xAxis: string[] = [];
      const seriesData: any = [];
      for (let i in data) {
        xAxis.push(i);
        if (props.valueLabel) {
          seriesData.push({
            name: i,
            value: data[i][props.valueLabel],
            v: data[i],
          });
        } else {
          seriesData.push({
            name: i,
            value: data[i],
          });
        }
      }
      // data.forEach(item => {
      //   const { x, y } = item;
      //   xAxis.push(x);
      //   seriesData.push({
      //     name: x,
      //     value: y,
      //   });
      // });
      refChartOption.value.legend.data = xAxis;
      refChartOption.value.series[0].data = seriesData;
    };

    watch(
      () => props.data,
      () => {
        setChartOption(props.data);
      },
    );

    onMounted(() => {
      setChartOption(props.data);
    });
    return {
      chartHeight,
      refChartOption,
      setChartOption,
    };
  },
  components: {
    Chart,
  },
});
